import api from "../config";
const path = "user"

export default {
  getCurrent: () => {
    return api.get(`${path}/current`)
  }
}
